<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <a
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          @click="newPickupNote"
          v-if="auth.can('PICK_UP')"
        >
          Nouveau Bon
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </a>
        <!-- <button v-if="auth.can('EXPORT_CLIENT')"
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
        >
          Export
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button> -->
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Search customer"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table :columns="headers" :rows="rows">
        <!-- Empty state -->
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <!-- Custom row -->
        <template #table-row="props">
          <span v-if="props.column.field == 'created_at'">
            {{ getDate(props.row.created_at) }}
          </span>
          <template v-else-if="props.column.field === 'statut'">
            <span
              :class="`fs-13 me-5 mt-10 badge text-bg-${resolveStatusVariant(props.row.statut)}`"
            >
              <template v-if="props.row.statut == 0">Nouveau ramassage</template>
              <template v-else-if="props.row.statut == 1">Traité</template>
              <template v-else-if="props.row.statut == 2">Reçu</template>
            </span>
          </template>

          <span v-else-if="props.column.field == 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li v-if="props.row.statut == 0">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click.prevent="
                      $router.push({
                        name: 'EditPickupPage',
                        params: { id: props.row.id , refCode: props.row.note_ref },
                      })
                    "
                  >
                    <i
                      class="flaticon-pen lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </a>
                </li>
                <li v-if="props.row.statut == 0 && props.row.nb_requests != 0">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="saveNote(props.row)"
                  >
                    <i class="ph ph-floppy-disk lh-1 me-8 position-relative top-1"></i>
                    Enregistrer
                  </a>
                </li>

                <li v-if="props.row.statut == 1">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="receiveNote(props.row)"
                  >
                    <i class="ph ph-check-circle lh-1 me-8 position-relative top-1"></i>
                    Recevoir
                  </a>
                </li>

                <li v-if="props.row.statut == 0 && props.row.nb_requests == 0">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="deletePoint(props.row)"
                  >
                    <i
                      class="flaticon-delete lh-1 me-8 position-relative top-1"
                    ></i>
                    Supprimer
                  </a>
                </li>

                <li v-if="props.row.nb_requests != 0">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="notePdf(props.row)"
                  >
                    <i
                      class="flaticon-file lh-1 me-8 position-relative top-1"
                    ></i>
                    Télécharger
                  </a>
                </li>
              </ul>
            </div>
          </span>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="users"
        :offset="9"
        @paginate="fetchData"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import router from "@/router";
export default {
  name: "ListPickup",
  setup: () => {
    const { showToast } = useAppToast();

    const auth = useAuthStore();
    const user = auth.user;

    const headers = [
      {
        label: "Référence",
        field: "note_ref",
      },
      {
        label: "Date de création",
        field: "created_at",
      },
      {
        label: "Statut",
        field: "statut",
      },
      {
        label: "Total",
        field: "nb_requests",
      },

      {
        label: "Action",
        field: "action",
      },
    ];

    const rows = ref([]);
    const loading = ref(false);

    const users = reactive({
      searchStatut: "",
      searchTerm: "",
      searchDate: "",
      searchEDate: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    // Fetch data from API
    const fetchData = async (page = 1) => {
      loading.value = true;
      users.current_page = page;

      try {
        const res = await api.get(`/api/auth/ListNotePickup`, {
          params: {
            searchTerm: users.searchTerm,
            searchStatut: users.searchStatut,
            searchDate: users.searchDate,
            searchEDate: users.searchEDate,
            page: users.current_page,
            per_page: users.per_page,
          },
        });

        rows.value = res.data.users.data;
        Object.assign(users, res.data.users);
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    };

    onMounted(async () => {
      fetchData();
    });

    function getDate(value: any) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    async function adminLogin(customer) {
      window.open(
        process.env.VUE_APP_DOMAIN_CUSTOMER +
          "/HashLogin/" +
          customer.id +
          "/" +
          user?.id
      );
    }

    function resolveStatusVariant(status) {
      if (status == 0) return "warning";
      if (status == 1) return "primary";
      if (status == 2) return "success";
      return "secondary";
    }

    async function saveNote(row) {
      try {
        const result = await Swal.fire({
          text: "Vous voulez enregistrer ce bon ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, enregistrer!",
        });

        if (!result.isConfirmed) return; // Exit early if canceled

        const res = await api.post(`/api/auth/SaveNotePickup/${row.id}`, {
          active: Number(!row.active),
        });

        switch (res.data.msg) {
          case "success":
            fetchData();
            showToast("Bon de ramassage est enregistré", "success");
            break;
          case "error":
            showToast("Erreur lors du sauvegarde du bon", "error");
            break;
          case "no note":
            showToast("Bon de ramassage n'existe pas", "error");
            break;
          default:
            showToast("Réponse inconnue du serveur", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Une erreur est survenue, veuillez réessayer", "error");
      }
    }

    async function deletePoint(row) {
      try {
        const result = await Swal.fire({
          text: "Vous voulez supprimer ce bon ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, supprimer!",
        });

        if (!result.isConfirmed) return; // Exit if canceled

        const res = await api.post(`/api/auth/DestroyPoint/${row.id}`, {
          active: Number(!row.active),
        });

        if (res.data.message === "success") {
          fetchData();
          showToast("Bon de réception est supprimé", "success");
        } else {
          showToast("Erreur lors de la suppression du bon", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Une erreur est survenue, veuillez réessayer", "error");
      }
    }

    async function notePdf(row) {
      try {
        const res = await api.get(`/api/auth/NotePickupPdf/${row.id}`, {
          responseType: "arraybuffer",
        });

        // Create a blob from the response
        const blob = new Blob([res.data], { type: "application/pdf" });

        // Create a temporary link
        const link = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        // Open in a new tab
        window.open(url, "_blank");

        // Optional: Uncomment to download the PDF instead of opening
        // link.download = `${row.note_ref || 'note'}.pdf`;
        // link.click();

        // Clean up the URL object
        setTimeout(() => window.URL.revokeObjectURL(url), 100);
      } catch (error) {
        console.error(error);
        showToast("Impossible de générer le PDF, veuillez réessayer", "error");
      }
    }

    async function receiveNote(row: any) {
      try {
        const result = await Swal.fire({
          text: "Vous voulez marquer ce bon comme reçu ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, recevoir!",
        });

        if (!result.isConfirmed) return;

        const res = await api.post(`/api/auth/ReceiveNotePickup/${row.id}`);

        switch (res.data.msg) {
          case "success":
            fetchData();
            showToast("Bon de ramassage marqué comme reçu", "success");
            break;
          case "error":
            showToast("Erreur lors de la réception du bon", "error");
            break;
          case "no note":
            showToast("Bon de ramassage n'existe pas", "error");
            break;
          default:
            showToast(res.data.msg || "Réponse inconnue du serveur", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Une erreur est survenue, veuillez réessayer", "error");
      }
    }

    async function newPickupNote() {
      try {
        const res = await api.post(`/api/auth/NewNotePickup`);

        if (res.data.msg === "success" && res.data.note?.id) {
          showToast("Les données sont bien sauvegardées", "success");
          router.push({
            name: "EditPickupPage",
            params: { id: res.data.note.id, refCode: res.data.note.note_ref  },
          });
        } else {
          showToast("Une erreur est survenue, veuillez réessayer", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Une erreur est survenue, veuillez réessayer", "error");
      }
    }

    return {
      headers,
      rows,
      users,
      loading,
      fetchData,
      getDate,
      adminLogin,
      auth,
      resolveStatusVariant,
      saveNote,
      receiveNote,
      deletePoint,
      notePdf,
      newPickupNote,
    };
  },
};
</script>